import { GlsInitRequestPayload } from './types';

export type BuildGlsInitPayloadInput = {
  userId: string;
  ip: string;
  loginToken: string;
  authToken: string;
  gameUid: string;
  lobbyUrl: string;
  geolocationToken: string;
  platform: string;
  jackpotMode?: boolean;
  product?: string;
  /** Defaults to `true` (Prismic/Redis game metadata). Reconcile relaunches use `false`. */
  usePrismic?: boolean;
  provider?: string;
  providerRef?: string;
  directLaunchParams?: Record<string, unknown>;
};

export const buildGlsInitPayload = (
  input: BuildGlsInitPayloadInput,
): GlsInitRequestPayload => ({
  userId: input.userId,
  ip: input.ip,
  usePrismic: input.usePrismic ?? true,
  loginToken: input.loginToken,
  gameUid: input.gameUid,
  lobbyUrl: input.lobbyUrl,
  authToken: input.authToken,
  geolocationToken: input.geolocationToken,
  platform: input.platform,
  jackpotMode: input.jackpotMode,
  ...(input.product ? { product: input.product } : {}),
  ...(input.provider ? { provider: input.provider } : {}),
  ...(input.providerRef ? { providerRef: input.providerRef } : {}),
  ...(input.directLaunchParams
    ? { slices: { directLaunchParams: input.directLaunchParams } }
    : {}),
});
